import { readItems, readSingleton } from '@directus/sdk';
import '$lib/i18n';
import { browser } from '$app/environment';
import { resetLang } from '$lib/utilities';
import { getApplicationServices } from '$lib/GetApplicationServices';
import { invalidateAll } from '$app/navigation';
import { user } from '$lib/stores';

export const ssr = false;

let lastIsLoggedIn = false;

export async function load({ fetch }) {
	const services = await getApplicationServices(fetch, (services) => {
		services.auth.onIsLoggedInChanged.subscribe(async (loginStatus) => {
			if (!loginStatus) return;
			if (loginStatus.userId) {
				user.set(loginStatus.userId);
			}
			if (navigator.serviceWorker.controller) {
				navigator.serviceWorker.controller.postMessage({
					type: 'SET_USER_ID',
					userId: loginStatus?.userId
				});
			}

			const statusChanged = lastIsLoggedIn !== loginStatus.isLoggedIn;
			lastIsLoggedIn = loginStatus.isLoggedIn;
			if (statusChanged && !loginStatus.isLoggedIn) {
				await invalidateAll();
			}
		});
	});
	const { directus, auth } = services;

	if (browser) {
		resetLang();
	}

	return {
		auth: services.auth,
		directus: services.directus,
		services: services,
		languages: await directus.request(
			readItems('languages', {
				filter: { status: 'published' },
				fields: ['code', 'name', 'admin_lang', 'iso_week']
			})
		),
		legal: await directus.request(
			readSingleton('legal', {
				fields: [{ translations: ['*'] }]
			})
		),
		about: await directus.request(
			readSingleton('about', {
				fields: [{ translations: ['*'] }]
			})
		)
	};

}
